import * as api from "./level-test-progress.api";
import * as mocks from "./level-test-progress.mocks";
import config from "@/config/config";
import type {
  GetProgressDebugRequest,
  GetProgressDebugResponse,
} from "./level-test-progress.interfaces";

/**
 * Service selector para Level Test Progress Debug
 * Seleciona automaticamente entre implementação real (API) ou mock baseado em VITE_USE_REAL_API
 */

/**
 * Obter dados de debug do progresso do teste de nivelamento
 * Seleciona automaticamente entre implementação real (API) ou mock baseado em config.useRealApi
 */
export const getProgressDebug = async (
  request: GetProgressDebugRequest
): Promise<GetProgressDebugResponse> => {
  return config.useRealApi
    ? api.apiGetProgressDebug(request)
    : mocks.mockGetProgressDebug(request);
};

